import { AxiosResponse } from "axios";
import { api } from "./base/api";
import { KeyValue } from "../models/common";
import { Result } from "../models/common/resultResponse";
import { VoucherDetailRequest, VoucherSearchGridRequest } from "../models/request";
import { VoucherDetailResponse, VoucherSearchGridResponse } from "../models/response";
import { IVoucherApi } from "./base";

const baseRoute: string = "Voucher";

export class VoucherApi extends IVoucherApi {
	getVoucherTypes(): Promise<AxiosResponse<Result<KeyValue[]>>> {
		return api.get(`${baseRoute}/voucher-types`);
	}

	getVoucherRefundStatus(): Promise<AxiosResponse<Result<KeyValue[]>>> {
		return api.get(`${baseRoute}/voucher-refund-status`);
	}

	getRefunds(request: VoucherSearchGridRequest): Promise<AxiosResponse<Result<VoucherSearchGridResponse>>> {
		return api.post(`${baseRoute}/refunds`, request);
	}

	getClaimVouchers(
		request: VoucherDetailRequest,
		abortSignal?: AbortSignal,
	): Promise<AxiosResponse<Result<VoucherDetailResponse>>> {
		return api.post(`${baseRoute}/claim-vouchers`, request, {
			signal: abortSignal,
		});
	}
}
